import { keyframes } from 'styled-components';
import { CssAnimation } from './CssAnimation';

const frames = keyframes`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.3;
  }

  100% {
    opacity: 1;
  }
`;

export const PulseFadeAnimation: CssAnimation = {
    duration: 1000,
    keyframes: frames,
    loop: true,
};
